module.exports = __webpack_public_path__ + "img/Computational_-_NE-t-20883-003.08c75b70.jpg";